/* ============================================================
   NL Invisible Lift — click-to-play video boxes
   Used by the Recognition cards and the Walk In media. The real
   <video>/<iframe> waits inside a <template> until the shopper
   clicks the poster, so a page full of review videos costs
   nothing on load.
   Loaded by the NL sections; the guard keeps the handler single
   even though several sections tag the same script.
   ============================================================ */
(function () {
  'use strict';
  if (window.__nlIlVideoReady) return;
  window.__nlIlVideoReady = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-nl-video]') : null;
    if (!btn) return;
    var wrap = btn.parentElement;
    if (!wrap) return;
    var tpl = wrap.querySelector('template[data-nl-video-embed]');
    if (!tpl) return;
    var frag = tpl.content.cloneNode(true);
    var media = frag.querySelector('video, iframe');
    if (!media) return;

    if (media.tagName === 'VIDEO') {
      // set before the element enters the document so iOS honours it
      media.setAttribute('playsinline', '');
      media.setAttribute('webkit-playsinline', '');
      media.setAttribute('controls', '');
    }

    tpl.parentNode.removeChild(tpl);
    btn.parentNode.removeChild(btn);
    wrap.appendChild(frag);

    if (media.tagName === 'VIDEO') {
      // the click is the user gesture, so this plays with sound
      var p = media.play();
      if (p && p.catch) p.catch(function () {});
    }
  });
})();
